// Static dataset for Onboarding location pickers — kept here to keep Onboarding.jsx small.

export const COUNTRIES = [
  { code: "TR", label: "Türkiye", en: "Turkey" },
  { code: "DE", label: "Almanya", en: "Germany" },
  { code: "NL", label: "Hollanda", en: "Netherlands" },
  { code: "GB", label: "Birleşik Krallık", en: "United Kingdom" },
  { code: "US", label: "Amerika Birleşik Devletleri", en: "United States" },
  { code: "FR", label: "Fransa", en: "France" },
  { code: "AT", label: "Avusturya", en: "Austria" },
  { code: "BE", label: "Belçika", en: "Belgium" },
  { code: "CH", label: "İsviçre", en: "Switzerland" },
  { code: "AE", label: "Birleşik Arap Emirlikleri", en: "United Arab Emirates" },
  { code: "AZ", label: "Azerbaycan", en: "Azerbaijan" },
  { code: "OTHER", label: "Diğer", en: "Other" },
];

// Sectors — `value` is the Turkish canonical key that the backend (intent
// mapping, sector preview, scoring prompts) expects. `en` is the label
// shown to English users. Adding/renaming a sector MUST also update the
// backend mapping; the EN label is a pure UI translation.
export const SECTORS = [
  { value: "Restoran / Kafe", en: "Restaurant / Cafe" },
  { value: "Diş Kliniği", en: "Dental Clinic" },
  { value: "Güzellik Salonu / Kuaför", en: "Beauty Salon / Hairdresser" },
  { value: "Estetik Klinik", en: "Aesthetic Clinic" },
  { value: "Avukat / Hukuk Bürosu", en: "Lawyer / Law Firm" },
  { value: "Muhasebe / Mali Müşavir", en: "Accounting / Financial Advisor" },
  { value: "Emlak Ofisi", en: "Real Estate Office" },
  { value: "Eğitim / Kurs", en: "Education / Course" },
  { value: "Spor Salonu / Fitness", en: "Gym / Fitness" },
  { value: "Veteriner Klinik", en: "Veterinary Clinic" },
  { value: "Otel / Pansiyon", en: "Hotel / Guesthouse" },
  { value: "Oto Servis / Galeri", en: "Auto Service / Dealership" },
  { value: "E-Ticaret / Mağaza", en: "E-commerce / Store" },
  { value: "Sağlık Kliniği / Doktor", en: "Health Clinic / Doctor" },
  { value: "Mimar / İç Mimar", en: "Architect / Interior Designer" },
  { value: "Yazılım / Ajans", en: "Software / Agency" },
  { value: "Diğer", en: "Other" },
];

export function sectorLabel(value, lang) {
  if (lang !== "en") return value;
  const found = SECTORS.find((s) => s.value === value);
  return found ? found.en : value;
}

export function countryLabel(c, lang) {
  return lang === "en" ? c.en || c.label : c.label;
}

// 81 Turkish provinces (alphabetical order)
export const TR_CITIES = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara",
  "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman",
  "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa",
  "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne",
  "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
  "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir",
  "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri",
  "Kilis", "Kırıkkale", "Kırklareli", "Kırşehir", "Kocaeli", "Konya", "Kütahya",
  "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde",
  "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Şanlıurfa", "Siirt",
  "Sinop", "Şırnak", "Sivas", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak",
  "Van", "Yalova", "Yozgat", "Zonguldak",
];

// Districts for the three biggest metropolitan cities. For other Turkish provinces
// the district input falls back to a manual text field.
export const TR_DISTRICTS = {
  İstanbul: [
    "Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler",
    "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü",
    "Beyoğlu", "Büyükçekmece", "Çatalca", "Çekmeköy", "Esenler", "Esenyurt",
    "Eyüpsultan", "Fatih", "Gaziosmanpaşa", "Güngören", "Kadıköy", "Kağıthane",
    "Kartal", "Küçükçekmece", "Maltepe", "Pendik", "Sancaktepe", "Sarıyer",
    "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli", "Tuzla", "Ümraniye",
    "Üsküdar", "Zeytinburnu",
  ],
  Ankara: [
    "Akyurt", "Altındağ", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çankaya",
    "Çubuk", "Elmadağ", "Etimesgut", "Evren", "Gölbaşı", "Güdül", "Haymana",
    "Kalecik", "Kazan", "Keçiören", "Kızılcahamam", "Mamak", "Nallıhan",
    "Polatlı", "Pursaklar", "Sincan", "Şereflikoçhisar", "Yenimahalle",
  ],
  İzmir: [
    "Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova",
    "Buca", "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe",
    "Karabağlar", "Karaburun", "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz",
    "Konak", "Menderes", "Menemen", "Narlıdere", "Ödemiş", "Seferihisar",
    "Selçuk", "Tire", "Torbalı", "Urla",
  ],
};

// Target audience options for the multi-select. The exact label strings get
// stored back into the `target_customer` field (comma-joined) so existing
// analysis prompts continue to read them as natural Turkish phrases.
export const TARGET_AUDIENCES = [
  "Bireysel müşteriler",
  "Aileler",
  "Çocuklu aileler",
  "Gençler",
  "Öğrenciler",
  "Kurumsal müşteriler",
  "Turistler",
  "Yerel müşteriler",
  "Premium müşteri kitlesi",
  "Acil hizmet arayanlar",
  "Sağlık / tedavi arayanlar",
  "Fiyat hassasiyeti olan müşteriler",
  "Diğer",
];

// EN labels for the TARGET_AUDIENCES values — UI-only translation, backend
// continues to store the original Turkish strings so prompts stay stable.
const AUDIENCE_EN = {
  "Bireysel müşteriler": "Individual customers",
  Aileler: "Families",
  "Çocuklu aileler": "Families with children",
  Gençler: "Young adults",
  Öğrenciler: "Students",
  "Kurumsal müşteriler": "Corporate clients",
  Turistler: "Tourists",
  "Yerel müşteriler": "Local customers",
  "Premium müşteri kitlesi": "Premium customer base",
  "Acil hizmet arayanlar": "Customers looking for urgent service",
  "Sağlık / tedavi arayanlar": "Customers seeking health / treatment",
  "Fiyat hassasiyeti olan müşteriler": "Price-sensitive customers",
  "Diğer": "Other",
};

export function audienceLabel(value, lang) {
  if (lang !== "en") return value;
  return AUDIENCE_EN[value] || value;
}
